import {
    FLOW_TYPE_ZONE_TICKET,
    FLOW_TYPE_FIXED_PRICE_TICKET,
    FLOW_TYPE_RETIREE_TICKET,
    FLOW_STEP_TRAVEL_INFORMATION,
    FLOW_STEP_CUSTOMER_INFORMATION,
    FLOW_STEP_CONFIRM_BASKET,
    FLOW_STEP_RETIREE_TICKET_PRODUCT
} from "@/store/modules/flow";

import paths from "./paths";

const PageNewZoneTicket = () =>
    import(
        /* webpackMode: "lazy", webpackChunkName: "page-new-zone-ticket" */ "./pages/PageNewZoneTicket"
    );
const PageRetireeProducts = () =>
    import(
        /* webpackMode: "lazy", webpackChunkName: "page-retiree-products" */ "./pages/PageRetireeProducts"
    );
const PageNewRetireeTicket = () =>
    import(
        /* webpackMode: "lazy", webpackChunkName: "page-new-retiree-ticket" */ "./pages/PageNewRetireeTicket"
    );
const PageNewFixedPriceTicket = () =>
    import(
        /* webpackMode: "lazy", webpackChunkName: "page-new-fixed-price-ticket" */ "./pages/PageNewFixedPriceTicket"
    );
const PageFixedPriceProducts = () =>
    import(
        /* webpackMode: "lazy", webpackChunkName: "page-fixed-price-products" */ "./pages/PageFixedPriceProducts"
    );
const PageCustomerInformation = () =>
    import(
        /* webpackMode: "lazy", webpackChunkName: "page-order-details" */ "./pages/PageCustomerInformation"
    );
const PageConfirmBasket = () =>
    import(
        /* webpackMode: "lazy", webpackChunkName: "page-order-details" */ "./pages/PageConfirmBasket"
    );

const routes = [
    {
        path: "/index.html",
        redirect: to => {
            if (to.query.id) {
                return {
                    name: "page_new_fixed_price_ticket",
                    query: { productId: to.query.id }
                };
            } else {
                return { name: "page_new_zone_ticket" };
            }
        }
    },
    {
        path: paths.newZoneTicket,
        name: "page_new_zone_ticket",
        component: PageNewZoneTicket,
        meta: {
            flowType: FLOW_TYPE_ZONE_TICKET,
            flowStep: FLOW_STEP_TRAVEL_INFORMATION,
            allowReload: true
        }
    },
    {
        path: paths.retireeProducts,
        name: "page_retiree_products",
        component: PageRetireeProducts,
        meta: {
            flowType: FLOW_TYPE_RETIREE_TICKET,
            allowReload: true
        }
    },
    {
        path: paths.newRetireeTicket,
        name: "page_new_retiree_ticket",
        component: PageNewRetireeTicket,
        meta: {
            flowType: FLOW_TYPE_RETIREE_TICKET,
            flowStep: FLOW_STEP_RETIREE_TICKET_PRODUCT,
            allowReload: true
        }
    },
    {
        path: paths.fixedPriceProducts,
        name: "page_fixed_price_products",
        component: PageFixedPriceProducts,
        meta: {
            flowType: FLOW_TYPE_FIXED_PRICE_TICKET,
            allowReload: true
        }
    },
    {
        path: paths.newFixedPriceTicket,
        name: "page_new_fixed_price_ticket",
        component: PageNewFixedPriceTicket,
        meta: {
            flowType: FLOW_TYPE_FIXED_PRICE_TICKET,
            flowStep: FLOW_STEP_TRAVEL_INFORMATION,
            allowReload: true
        }
    },
    {
        path: paths.customerInformation,
        name: "page_customer_information",
        component: PageCustomerInformation,
        meta: {
            flowStep: FLOW_STEP_CUSTOMER_INFORMATION
        }
    },
    {
        path: paths.confirmBasket,
        name: "page_confirm_basket",
        component: PageConfirmBasket,
        meta: {
            flowStep: FLOW_STEP_CONFIRM_BASKET
        }
    }
];

export default routes;
